var _excluded = ["options"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext, useRef, useState } from "react";
import OnColorContext from "../../../contexts/OnColorContext";
import useClickOutside from "../../../hooks/useClickOutside";
import useEscClick from "../../../hooks/useEscClick";
import BreakpointVisibilityOrg from "../../organisms/BreakpointVisibilityOrg";
import FlexContainerOrg from "../../organisms/FlexContainerOrg";
import FlexItemOrg from "../../organisms/FlexItemOrg";
import { Container, SelectContent, Icon, Link, Option, Options, optionsBackground, Select, Label, AnimatedArrow, ArrowWrapper, IconContainer } from "./SelectWithLinksMol.styled";
function SelectWithLinksMol(_ref) {
  var options = _ref.options,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var containerRef = useRef(null);
  var onColor = useContext(OnColorContext);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  useClickOutside(containerRef, function () {
    return setIsOpen(false);
  });
  useEscClick(containerRef, function () {
    return setIsOpen(false);
  });
  var handleSelectClick = function handleSelectClick() {
    setIsOpen(function (value) {
      return !value;
    });
  };
  var handleSelectMouseEnter = function handleSelectMouseEnter() {
    setIsOpen(true);
  };
  var handleSelectMouseLeave = function handleSelectMouseLeave() {
    setIsOpen(false);
  };
  var optionsData = /*#__PURE__*/React.createElement(React.Fragment, null, options.length > 1 ? /*#__PURE__*/React.createElement(Options, {
    $isOpen: isOpen
  }, /*#__PURE__*/React.createElement(OnColorContext.Provider, {
    value: optionsBackground
  }, options.slice(1).map(function (option) {
    return /*#__PURE__*/React.createElement(Option, {
      key: option.label
    }, /*#__PURE__*/React.createElement(FlexContainerOrg, {
      justifyContent: "flex-start",
      alignItems: "center"
    }, /*#__PURE__*/React.createElement(Link, option.link, /*#__PURE__*/React.createElement(IconContainer, null, /*#__PURE__*/React.createElement(Icon, {
      $backgroundColor: option.icon.backgroundColor
    }, option.icon.image)), /*#__PURE__*/React.createElement(Label, {
      typography: {
        small: "small2",
        medium: "medium2_s",
        large: "medium2_s"
      }
    }, option.label))));
  }))) : null);
  var SelectData = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FlexContainerOrg, {
    justifyContent: "space-between",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(IconContainer, null, /*#__PURE__*/React.createElement(Icon, {
    $backgroundColor: options[0].icon.backgroundColor
  }, options[0].icon.image)), /*#__PURE__*/React.createElement(FlexItemOrg, {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 0
  }, /*#__PURE__*/React.createElement(FlexContainerOrg, {
    direction: "column",
    justifyContent: "flex-start"
  }, /*#__PURE__*/React.createElement(Label, {
    typography: {
      small: "small2",
      medium: "medium2_s",
      large: "medium2_s"
    }
  }, options[0].label))), /*#__PURE__*/React.createElement(ArrowWrapper, null, /*#__PURE__*/React.createElement(AnimatedArrow, {
    $isOpen: isOpen,
    $onColor: onColor
  }))));
  return /*#__PURE__*/React.createElement(Container, _extends({}, restProps, {
    ref: containerRef
  }), /*#__PURE__*/React.createElement(BreakpointVisibilityOrg, {
    from: "large"
  }, /*#__PURE__*/React.createElement(SelectContent, {
    onMouseEnter: handleSelectMouseEnter,
    onMouseLeave: handleSelectMouseLeave,
    $onColor: onColor,
    $isOpen: isOpen
  }, /*#__PURE__*/React.createElement(Select, {
    $isOpen: isOpen
  }, SelectData), optionsData)), /*#__PURE__*/React.createElement(BreakpointVisibilityOrg, {
    from: "small",
    to: "large"
  }, /*#__PURE__*/React.createElement(SelectContent, {
    $onColor: onColor,
    $isOpen: isOpen
  }, /*#__PURE__*/React.createElement(Select, {
    onClick: handleSelectClick,
    $isOpen: isOpen
  }, SelectData), optionsData)));
}
export default SelectWithLinksMol;